// import images
import Logo from "../src/img/header/logo.svg";
import Img1 from "./img/gallery/1.jpeg";
import Img2 from "./img/gallery/2.jpeg";
import Img3 from "./img/gallery/3.jpeg";
import Img4 from "./img/gallery/4.jpeg";
import GalleryImg5 from "../src/img/gallery/5.jpg";
import GalleryImg6 from "../src/img/gallery/6.jpg";
import GalleryImg7 from "../src/img/gallery/7.jpg";
import GalleryImg8 from "../src/img/gallery/8.jpg";
import QuoteImg from "../src/img/testimonial/quote.svg";
// import icons
import { GrFacebookOption} from "react-icons/gr";
import { IoMdArrowForward } from "react-icons/io";
import { FiSend } from "react-icons/fi";
import { FaPlay, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaTiktok, FaYoutube } from "react-icons/fa";
import {
  IoLogoInstagram,
  IoLogoTwitter,
  
} from "react-icons/io";

export const headerData = {
  logo: Logo,
};

export const navData = {
  items: [
    { href: "/", name: "Home" },
    { href: "/about", name: "About" },
    { href: "/gallery", name: "Gallery" },
    { href: "/interview", name: "Interview" },
    { href: "/articles", name: "Articles" },
    { href: "/contact", name: "Contact" },
  ],
};

export const socialData = [
  { href: "https://www.facebook.com/ta.lel.818040", icon: <GrFacebookOption /> },
  { href: "https://www.instagram.com/inkbytorino/", icon: <IoLogoInstagram /> },
  { href: "https://www.tiktok.com/@inktorino?lang=fr", icon: <FaTiktok /> },
  { href: "/", icon: <IoLogoTwitter /> },
  { href: "/", icon: <FaYoutube /> },
];

export const heroData = {
  title: "I’m Talel.Bouazizi.",
  subtitle:
    "Tattoos have their own unique power and magic. They not only beautify the body but also the psyche.",
  btnText: "read more",
  btnIcon: <IoMdArrowForward />,
};

export const aboutData = {
  title: "My Story:",
  subtitle1:
    "In velit arcu posuere integer. Dolor sit amet, consectetur nun adipiscing elit. Duis porttitor massa tellus hac vel ante sit sed scelerisque praesent duis volutpat laoreet.",
  subtitle2:
    "Nisl, sit molestie commodo congue. Etiam lectus risus in amet. Commodo molestie fames etiam aenean sed. Pellentesque et venenatis amet, tellus hac vel adipiscing sit. Placerat vitae nisl viverra faucibus tincidunt habitasse amet. Nunc, velit nunc, scelerisque imperdiet nunc.",
  btnText: "Know more",
  btnIcon: <IoMdArrowForward />,
};

export const galleryData = {
  title: "Check my gallery:",
  btnText: "View all",
  btnIcon: <IoMdArrowForward />,
  images: [
    {
      src: Img1,
      original: Img1,
      width: 465,
      height: 412,
    },
    {
      src: Img2,
      original: Img2,
      width: 465,
      height: 540,
    },
    {
      src: Img3,
      original: Img3,
      width: 465,
      height: 412,
    },
    {
      src: Img4,
      original: Img4,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg5,
      original: GalleryImg5,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg6,
      original: GalleryImg6,
      width: 464,
      height: 412,
    },
    {
      src: GalleryImg7,
      original: GalleryImg7,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg8,
      original: GalleryImg8,
      width: 465,
      height: 412,
    },
  ],
};

export const interviewData = {
  title:
    "“Consider what you desire. Your tattoo artist will never tell you what tattoo to have.”",
  btnText: "Watch it now",
  btnIcon: <FaPlay />,
};

export const testimonialData = [
  {
    quoteImg: QuoteImg,
    message:
      "The entire team is extremely kind and friendly. They're fantastic. They're great at what they do! And it's unique.They will properly consult with you.",
    name: "Jack Geoffrey",
    occupation: "Tattoo Artist",
  },
  {
    quoteImg: QuoteImg,
    message:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam culpa asperiores officia natus dignissimos autem possimus molestias aperiam?",
    name: "Douglas Hane",
    occupation: "Tattoo Artist",
  },
];

export const contactData = {
  title: "Get in touch with me:",
  info: [
    {
      title: "Sfax, Tunisia",
      subtitle:
        "In velit arcu posuere integer sit amet, consectetur nun adipiscing elit. Duis porttitor massa tellus",
      address: {
        icon: <FaMapMarkerAlt />,
        name: "Saltnia km 10 , Sfax",
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: "+216 52260368",
      },
      email: {
        icon: <FaEnvelope />,
        address: "contact@yourcompany.com",
      },
      link: "Get location",
    },
    {
      title: "Sfax , Tunisia",
      subtitle:
        "Sit amet, consectetur nun in velit arcu posuere integer. Adipiscing elit duis porttitor massa tellus",
      address: {
        icon: <FaMapMarkerAlt />,
        name: "Hamza, Sidi mansour, Sfax",
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: "+216 52260368",
      },
      email: {
        icon: <FaEnvelope />,
        address: "contact@yourcompany.com",
      },
      link: "Get location",
    },
  ],
  form: {
    name: "Write your name here",
    email: "Write your email address",
    message: "Write your messages here",
    btnText: "Send it",
  },
};

export const footerData = {
  about: {
    title: "About tattoo studio",
    subtitle:
      "Sit amet, consectetur nun in velit arcu posuere integer. Adipiscing elit duis porttitor massa tellus",
    address: {
      icon: <FaMapMarkerAlt />,
      name: "Saltnia Km 10 , Sfax",
    },
    phone: {
      icon: <FaPhoneAlt />,
      number: "+216 52260368",
    },
    email: {
      icon: <FaEnvelope />,
      address: "contact@yourcompany.com",
    },
  },
  links: {
    title: "Useful links",
    items: [
      { href: "/", name: "About me" },
      { href: "/", name: "My gallery" },
      { href: "/", name: "My services" },
      { href: "/", name: "Contact me" },
    ],
  },
  program: {
    title: "Working Time",
    items: [
      { name: "Mon -/ Appointment" },
      { name: "Wed- Tue - Fri / 11:00 - 11:00pm" },
      { name: "Sat / 12:00 - 02:00am" },
      { name: "Sun / work 24/24" },
    ],
  },
  newsletter: {
    title: "Newsletter",
    subtitle:
      "Elit duis porttitor massa tellus nun in velit arcu posuere integer.",
    form: {
      placeholder: "Your email address",
      icon: <FiSend />,
    },
  },
};
